// tourConfig.js
export const steps = [
  {
    target: ".menu-item-dashboard",
    content:
      "Vous trouverez dans cet onglet le tableau de bord qui vous présentera les informations essentielles",
    placement: "bottom",
  },
  {
    target: ".menu-item-patients",
    content:
      "Ici, vous pouvez voir et gérer la liste des patients ou de vos employés.",
    placement: "bottom",
  },
  {
    target: ".menu-item-users",
    content: "Gérez les comptes et les permissions des utilisateurs ici.",
    placement: "bottom",
  },
  {
    target: ".menu-item-database",
    content: "Gérez vos données depuis cet onglet.",
    placement: "bottom",
  },
  {
    target: ".menu-item-scan",
    content: "Scannez les cartes patients ici.",
    placement: "bottom",
  },
  {
    target: ".menu-item-history",
    content: "Voir l'historique des entrées/sorties et de connexions ici.",
    placement: "bottom",
  },
  {
    target: ".menu-item-update",
    content: "importer les informations depuis Santymed depuis cet onglet.",
    placement: "bottom",
  },
  {
    target: ".menu-item-logout",
    content: "Déconnectez-vous de l’application ici.",
    placement: "bottom",
  },
  // Add more steps as needed
];
